import { EuiFilterButton } from "@elastic/eui";
import styled from "styled-components";

export const EuiFilterButtonWrapper = styled(EuiFilterButton)`
    min-width: 250px;
    padding: 0 8px;
    .groupBy-value__badge {
        margin-inline-start: 10px;
    }
`;
